/* assets/fhn-purchase-options.js
   Controla el selector Suscripción / Compra única.
   - Suscripción: oculta xboost y el botón de carrito, muestra el botón de Treli.
   - Compra única: muestra xboost y el botón de carrito del formulario.
*/
(function () {
  if (window.__fhnPoInit) return;
  window.__fhnPoInit = true;

  var fmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  function money(cents) { return '$' + fmt.format(Math.round(cents / 100)); }

  function init(root) {
    if (root.__po) return;
    root.__po = true;

    // Contenedor de la columna de info: aquí se aplica la clase que oculta xboost / ATC
    var scope = root.closest('.t4s-product__info-wrapper') || document.body;
    var coupon = root.dataset.coupon || '';
    var qtyParam = root.dataset.qtyParam || '';
    var unit = parseInt(root.dataset.unitPrice, 10) || 0;

    var modes = root.querySelectorAll('[data-po-mode]');
    var body = root.querySelector('[data-po-body]');
    var freqs = root.querySelectorAll('[data-po-freq]');
    var qty = root.querySelector('[data-po-qty]');
    var btn = root.querySelector('[data-po-sub-btn]');
    var total = root.querySelector('[data-po-total]');

    function currentQty() {
      var n = parseInt(qty.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function buildUrl() {
      var checked = root.querySelector('[data-po-freq]:checked');
      if (!checked) return;
      var url;
      try { url = new URL(checked.value); } catch (e) { return; }
      if (coupon) url.searchParams.set('coupon_code', coupon);
      // El parámetro de cantidad solo se envía cuando está configurado en el editor
      if (qtyParam) url.searchParams.set(qtyParam, currentQty());
      btn.href = url.toString();
    }

    function updateTotal() {
      if (total) total.textContent = money(unit * currentQty());
    }

    function setMode(mode) {
      var isSub = mode === 'sub';
      scope.classList.toggle('fhn-po-is-sub', isSub);
      root.querySelectorAll('[data-po-card]').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.poCard === mode);
      });
      if (body) body.hidden = !isSub;
    }

    modes.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) setMode(r.value); });
    });
    freqs.forEach(function (r) { r.addEventListener('change', buildUrl); });

    root.querySelectorAll('[data-po-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, Math.min(99, currentQty() + parseInt(b.dataset.poStep, 10)));
        updateTotal(); buildUrl();
      });
    });
    qty.addEventListener('input', function () { updateTotal(); buildUrl(); });
    qty.addEventListener('blur', function () { qty.value = currentQty(); });

    var initial = root.querySelector('[data-po-mode]:checked');
    setMode(initial ? initial.value : 'sub');
    buildUrl();
    updateTotal();
  }

  function run() { document.querySelectorAll('[data-fhn-po]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Editor de temas: reinicializa al recargar la sección
  document.addEventListener('shopify:section:load', run);
})();
